/* eslint-disable react/no-danger */
import Typography from '@common_typography';
import Button from '@common_button';
import TextField from '@common_forms/TextField';
import { getStoreHost } from '@helpers/config';
import ReCAPTCHA from 'react-google-recaptcha';
import dynamic from 'next/dynamic';

const Message = dynamic(() => import('@common_toast'), { ssr: false });

const ContactForm = (props) => {
    const {
        //
        t,
        formik,
        sitekey,
        handleChangeCaptcha,
        recaptchaRef,
        message,
        setMessage,
        load,
        enableRecaptcha,
    } = props;
    return (
        <form onSubmit={formik.handleSubmit} className="mt-2">
            <Message open={message.open} variant={message.variant} setOpen={() => setMessage({ ...message, open: false })} message={message.text} />
            <TextField
                label={t('contact:fullName')}
                name="fullName"
                value={formik.values.fullName}
                onChange={formik.handleChange}
                hintProps={{
                    displayHintText: !!(formik.touched.fullName && formik.errors.fullName),
                    hintType: formik.touched.fullName && formik.errors.fullName ? 'error' : '',
                    hintText: (formik.touched.fullName && formik.errors.fullName) || null,
                }}
                classWrapper="mb-4"
                className="max-tablet:w-full"
                absolute={false}
            />
            <TextField
                label={t('contact:email')}
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                hintProps={{
                    displayHintText: !!(formik.touched.email && formik.errors.email),
                    hintType: formik.touched.email && formik.errors.email ? 'error' : '',
                    hintText: (formik.touched.email && formik.errors.email) || null,
                }}
                classWrapper="mb-4"
                className="max-tablet:w-full"
                absolute={false}
            />
            <TextField
                label={t('contact:message')}
                name="message"
                multiline
                rows="4"
                value={formik.values.message}
                onChange={formik.handleChange}
                hintProps={{
                    displayHintText: !!(formik.touched.message && formik.errors.message),
                    hintType: formik.touched.message && formik.errors.message ? 'error' : '',
                    hintText: (formik.touched.message && formik.errors.message) || null,
                }}
                classWrapper="mb-4"
                className="max-tablet:w-full"
                absolute={false}
            />
            {enableRecaptcha ? (
                <>
                    <ReCAPTCHA sitekey={sitekey} onChange={handleChangeCaptcha} ref={recaptchaRef} />
                    {formik.touched.captcha && formik.errors.captcha && <Typography className="text-red">{formik.errors.captcha}</Typography>}
                </>
            ) : null}
            <div />
            <Button disabled={load} loading={load} align="left" type="submit" className="mt-4">
                <Typography variant="bd-2" className="uppercase">
                    {t('contact:contactSend')}
                </Typography>
            </Button>
            <style jsx global>
                {`
                    :root {
                        --image-url: url('${getStoreHost()}/media/wysiwyg/cms/contact-us/contact-us.png');
                    }
                    main {
                        padding: 0px !important;
                        margin: 0px !important;
                        max-width: unset !important;
                        min-height: 649px !important;
                    }
                    main:before {
                        content: '';
                        background: var(--image-url) left bottom no-repeat;
                        background-size: cover;
                        background-position: center;
                        width: 60%;
                        height: 100vh;
                        max-height: 649px;
                        border-right: 5px solid #fdd800;
                        display: flex;
                        flex-wrap: wrap;
                        box-sizing: inherit;
                        position: fixed;
                    }
                    main:after {
                        width: 40%;
                        height: 100vh;
                        max-height: 649px;
                        writing-mode: vertical-rl;
                        text-orientation: mixed;
                        align-content: center;
                        margin-left: -12px;
                        padding-left: 0;
                        content: 'Contact Us';
                        -webkit-text-stroke: 2px #f0f0f0;
                        -webkit-text-fill-color: #fff;
                        display: flex;
                        flex-wrap: wrap;
                        color: #f0f0f0;
                        font-size: 6rem;
                        font-weight: 700;
                        margin-top: -15px;
                        box-sizing: inherit;
                        position: fixed;
                        right: 0;
                    }
                    footer {
                        margin-top: 0px !important;
                    }
                    .form {
                        transform: translate(-50%, -50%);
                        z-index: 1;
                    }
                    .form form textarea {
                        height: 140px;
                    }
                    .contact-btn-container {
                        margin-top: 50px;
                    }
                    @media screen and (max-width: 576px) {
                        main:before {
                            width: 100%;
                            height: 200px;
                        }
                        main:after {
                            right: 0;
                            width: fit-content;
                            padding-right: 20px;
                            margin-top: 200px;
                            font-size: 5rem;
                        }
                    }
                `}
            </style>
        </form>
    );
};

const ContactPage = (props) => {
    const {
        //
        t,
        isCms,
    } = props;
    return (
        <div className="
            form
            absolute
            bg-neutral-white
            top-[50%]
            desktop:left-[64%]
            desktop:py-[31px]
            desktop:px-[30px]
            tablet:left-[58%]
            tablet:w-auto
            mobile:left-[50%]
            mobile:w-[300px]
            mobile:p-[20px]
            "
        >
            {/* eslint-disable-next-line react/no-danger */}
            {!isCms ? (
                <>
                    <Typography variant="h1" className="mb-4 !text-3xl capitalize">
                        {t('contact:contactUs')}
                    </Typography>
                    <Typography variant="bd-2a" className="my-2">
                        {t('contact:contactDesc')}
                    </Typography>
                </>
            ) : null}
            <ContactForm {...props} />
        </div>
    );
};

export default ContactPage;
